"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapSortValues = void 0;
const mapSortValues = (sort) => {
    switch (sort) {
        case 'priceasc':
            return 'priceAsc';
        case 'pricedsc':
            return 'priceDesc';
        case 'nosort':
            return 'random';
        case 'reviewsdsc':
            return 'reviewDesc';
        // TODO: It's a valid option but not something we display in the UI
        // case '':
        //   return 'reviewAsc'
        case 'sleepsdsc':
            return 'sleepsDesc';
        case 'sleepsasc':
            return 'sleepsAsc';
        case 'bestmatch':
            return 'bestMatch';
        case 'gradedsc':
            return 'gradeDesc';
        default:
            return sort;
    }
};
exports.mapSortValues = mapSortValues;
//# sourceMappingURL=search-properties-utils.js.map